import React, { PureComponent } from 'react'
import './index.css'

class Container extends PureComponent {
  render() {
    const { children, background, backgroundInner } = this.props

    return (
      <div
        className="container"
        style={ { background } }>
        <div
          className="container-inner"
          style={ { background: backgroundInner } }>
          <h1 className={ 'message-title' }>
            Cher Cath,
          </h1>
          
          { children }
        </div>
      </div>
    )
  }
}

export default Container



// WEBPACK FOOTER //
// ./src/components/Container/index.js